import { useEffect, useState } from 'react';

const useBulkSelect = (items, unreadIds, otherIds) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedUnreadItems, setSelectedUnreadItems] = useState([]);
  const [selectedOtherItems, setSelectedOtherItems] = useState([]);
  const [isAllUnreadSelected, setIsAllUnreadSelected] = useState(false);
  const [isAllOtherSelected, setIsAllOtherSelected] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);

  const toggleSelectedItem = (id) => {
    const isAlreadySelected = selectedItems.find((item) => item === id);
    const isUnreadSelected = unreadIds.find((item) => item === id);

    if (isUnreadSelected) {
      if (isAlreadySelected) {
        setSelectedItems(selectedItems.filter((item) => item !== id));
        setSelectedUnreadItems(selectedUnreadItems.filter((item) => item !== id));
      } else {
        setSelectedUnreadItems([...selectedUnreadItems, id]);
        setSelectedItems([...selectedItems, id]);
      }
    } else if (isAlreadySelected) {
      setSelectedItems(selectedItems.filter((item) => item !== id));
      setSelectedOtherItems(selectedOtherItems.filter((item) => item !== id));
    } else {
      setSelectedOtherItems([...selectedOtherItems, id]);
      setSelectedItems([...selectedItems, id]);
    }
  };

  const toggleUnreadAllSelected = (clean) => {
    if (clean) {
      setSelectedItems([]);
      setSelectedUnreadItems([]);
    } else {
      setSelectedItems([...selectedItems, ...unreadIds]);
      setSelectedUnreadItems(unreadIds);
    }
  };

  const toggleAllOthersSelected = (clean) => {
    if (clean) {
      setSelectedItems([]);
      setSelectedOtherItems([]);
    } else {
      setSelectedItems([...selectedItems, ...otherIds]);
      setSelectedOtherItems(otherIds);
    }
  };

  const isSelectedItem = (id) => !!selectedItems.find((item) => item === id);

  useEffect(() => {
    setIsAllUnreadSelected(
      unreadIds.length === selectedUnreadItems.length && unreadIds.length !== 0,
    );
    setIsAllOtherSelected(otherIds.length === selectedOtherItems.length && otherIds.length !== 0);
    setIsIndeterminate(
      !!selectedItems.length && selectedItems.length < items.length,
    );
  }, [selectedItems, items, unreadIds, selectedUnreadItems, otherIds, selectedOtherItems]);

  return {
    selectedItems,
    isIndeterminate,
    toggleSelectedItem,
    isSelectedItem,
    isAllUnreadSelected,
    isAllOtherSelected,
    toggleUnreadAllSelected,
    toggleAllOthersSelected,
    selectedUnreadItems,
    selectedOtherItems,
  };
};

export default useBulkSelect;
